<template>
  <blank-view>
    <div slot="action" style="display: flex; align-items: center; justify-content: space-between">
      <div>
        <a-button v-acl="'page_ops_work_record_add_1'" type="primary" style="margin-right: 8px" @click="handleAdd">
          <a-icon type="plus" />{{ $t('page_ops_work_record_add') }}
        </a-button>
        <a-button v-acl="'page_ops_work_record_delete'" style="margin-right: 8px" type="danger" :disabled="selectedRowKeys.length === 0" @click="handleDelete">
          {{ $t('delete') }}
        </a-button>
        <a-button style="margin-right: 8px" @click="exportWorkRecord">{{
          $t('page_ops_work_record_export')
        }}</a-button>
      </div>
      <div>
        <div class="flex status-choose">
          <div class="flex status-choose state-filter">
            {{ $t('page_ops_work_record_filter')+':' }}
            <template >
              <div v-for="status in dictList" :key="status.dictKey">
                <a-tag
                  v-if="inSearchStatus(status.dictKey)"
                  :color="status.remark"
                  @click="inputStatus(status.dictKey)"
                >
                  {{ status.dictValue }}
                </a-tag>
                <a-tag
                  v-else
                  style="background: #fff; borderstyle: dashed"
                  @click="inputStatus(status.dictKey)"
                >
                  {{ $t(status.dictValue) }}
                </a-tag>
              </div>
            </template>
          </div>
          <a-button style="margin-right: 8px" @click="toggleSearch" class="heightSearch">
            {{ $t('page_my_document_advanced') }}
          </a-button>
          <a-input-search
            :placeholder="$t('common_please_input') + $t('keyword')"
            :enterButton="$t('search')"
            allowClear
            style="width: 300px"
            v-model="filter.keywords"
            @search="keywordSearch"
          />
        </div>
      </div>
    </div>
    <div style="display: flex; flex-wrap: nowrap; height: 100%">
      <div id="table-list" class="custom-list">
        <ml-table
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          :columns="columns"
          :dataSource="dataSource"
          :canChangeColWidth="false"
          rowKey="id"
          :scroll="{ y: scrollY }"
          :selectRowKey="selectedRow && selectedRow.id"
          :customRow="
            (row) => ({
              on: {
                click: () => {
                  this.clickRow(row)
                }
              }
            })
          "
        >
          <template slot="action" slot-scope="text, record">
            <span v-if="!record.enableProcess">-</span>
            <span v-acl="'page_ops_work_record_status_distribute'">
              <a
                  v-if="record.enableProcess && record.processProgress == 1"
                  @click="distribute(record)"
              >{{ $t('page_ops_work_record_status_distribute') }}</a
              >
            </span>
            <span v-acl="'page_ops_work_record_claim'">
              <a v-if="record.enableProcess && record.processProgress == 2 && record.isClaim!==1 " @click.stop="startHandle(record)">{{
                  $t('page_ops_work_record_claim')
                }}</a>
            </span>
            <span v-acl="'page_ops_work_record_status_handle'">
              <a v-if="record.enableProcess && record.processProgress == 2 && record.isClaim===1 " @click.stop="handle(record)">{{
                  $t('page_ops_work_record_status_handle')
                }}</a>
            </span>
            <span v-acl="'page_ops_work_record_status_audit'">
              <a v-if="record.enableProcess && record.processProgress == 3" @click.stop="audit(record)">{{
                  $t('page_ops_work_record_status_audit')
                }}</a>
            </span>
            <span v-acl="'page_ops_work_record_edit_1'">
              <a style="margin-left:5px" v-if="record.enableProcess" @click.stop="edit(record)">{{
                  $t('edit')
                }}</a>
            </span>
          </template>
        </ml-table>
        <a-pagination
          size="small"
          style="position: absolute; bottom: 8px; right: 8px"
          :show-total="(total) => `${showTotal(total)}`"
          :current="pagination.current"
          :pageSize="pagination.pageSize"
          :total="pagination.total"
          @change="handleTableChange"
        />
      </div>
      <div class="custom-detail">
        <detail :work-record-id="selectedRow.id"></detail>
      </div>
    </div>

    <advance-search
      :sub-title="$t('page_ops_record_list')"
      :visible="advanceVisible"
      :formData="filter.advance"
      @close="closeToggleSearch"
      @advanceSearch="startToggleSearch"
      @reset="resetSearch"
    ></advance-search>

    <distribute-model
      ref="distribute"
      :visible="distributeModelVisible"
      @cancel="closeDistributeModel"
    >
    </distribute-model>
    <handle-model ref="handle" :visible="handleModelVisible" @cancel="closeHandleModel">
    </handle-model>
    <audit-model ref="audit" :visible="auditModelVisible" @cancel="closeAuditModel"> </audit-model>
    <new-model v-if="newModelVisible" ref="new" :visible="newModelVisible" @ok="okNewModel"  @cancel="closeNewModel" :isEdit="isEdit" :workRecordId="workRecordId"> </new-model>
  </blank-view>
</template>

<script>
import { Empty } from 'ant-design-vue'
import dayjs from 'dayjs'
import { mapGetters, mapActions } from 'vuex'
import { WorkRecordServiceProxy } from '@/service-proxies/app-v2/work-record.service-proxies'
const wrsp = new WorkRecordServiceProxy()

import { DictBizServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const dictServiceProxy = new DictBizServiceProxy()

import { exportWorkRecord } from '@/api/api'

import AdvanceSearch from '../common/components/advanceSearch'
import DistributeModel from './components/distribute.vue'
import AuditModel from './components/audit.vue'
import HandleModel from './components/handle.vue'
import NewModel from './components/new.vue'
import Detail from '../common/components/detail.vue'

export default {
  components: {
    AdvanceSearch,
    DistributeModel,
    AuditModel,
    HandleModel,
    NewModel,
    Detail
  },
  data() {
    return {
      selectedRow: {}, // 编辑数据
      chooseCustomerId: '',
      isEdit: false, // 是否是编辑
      workRecordId: undefined,
      advanceVisible: false,
      distributeModelVisible: false,
      handleModelVisible: false,
      auditModelVisible: false,
      newModelVisible: false,
      selectedRowKeys: [],
      filter: {
        keywords: '',
        status: [],
        advance: {
          areaId: undefined,
          areaName: '',
          regionName: '',
          submitUserId: undefined,
          request: '',
          contactUserName: '',
          deviceTypeIds: [],
          time: [],
          startTime: '',
          endTime: '',
          questionDescription: '',
          customerId: undefined,
          provinceId: undefined,
          provinceName: '',
          cityId: undefined,
          cityName: '',
          isInvolvedMachine: '',
          workStationId: undefined,
          claimUser: undefined
        },
        isAdvance: false,
        defaultAllStatus: []
      },
      columns: [
        {
          title: this.$t('actions'),
          dataIndex: 'action',
          key: 'action',
          width: 80,
          scopedSlots: { customRender: 'action' }
        },
        {
          title: this.$t('page_ops_work_record_document_number'),
          dataIndex: 'code',
          key: 'code',
          ellipsis: true,
          width: 130
        },
        {
          title: this.$t('page_ops_work_record_customer_name'),
          dataIndex: 'customerName',
          ellipsis: true,
          key: 'customerName'
        },
        {
          title: this.$t('page_ops_work_record_submit_time'),
          dataIndex: 'submitTime',
          key: 'submitTime',
          customRender: (t) => {
            return dayjs(t).format('YYYY-MM-DD HH:mm:ss') || ''
          },
          width: 150
        },
        {
          title: this.$t('page_ops_work_record_record_status'),
          dataIndex: 'processProgress',
          key: 'processProgress',
          width: 80,
          customRender: (s) => {
            let tagValue = this.getStateValue(s)
            return <a-tag color={tagValue.remark}>{tagValue.dictValue} </a-tag>
          }
        }
      ],
      dataSource: [],
      dictList: [],
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1
      },
      scrollY: 0
    }
  },
  watch: {
    '$route.query': {
      handler(v){
        this.filter.keywords = v.keyWord || ''
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters(['makinoJumpValue'])
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  async created() {
    await this.getStateDict()
    this.getData()
  },
  methods: {
    ...mapActions({
      saveMakinoJump: 'app/saveMakinoJump'
    }),
    getParams() {
      const params = {
        processProgress: this.getFilterStatus(),
        idList: this.selectedRowKeys,
        keyValue: this.filter.keywords,
        questionDesc: this.filter.advance.request,
        areaName: this.filter.advance.areaName,
        startTime: this.filter.advance.startTime,
        endTime: this.filter.advance.endTime,
        submitUserId: this.filter.advance.submitUserId,
        deviceTypeIds: this.filter.advance.deviceTypeIds,
        contactUserName: this.filter.advance.contactUserName,
        isAdvance: this.isAdvance,
        customerId: this.filter.advance.customerId,
        provinceName: this.filter.advance.provinceName,
        cityName: this.filter.advance.cityName,
        claimUser: this.filter.advance.claimUser,
        isInvolvedMachine: this.filter.advance.isInvolvedMachine,
        workstationId: this.filter.advance.workStationId
      }
      return params;
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(current) {
      this.pagination.current = current
      if (!this.isAdvance) {
        this.getData()
      } else {
        this.advanceSearch()
      }
    },
    resetSearch() {
      this.filter.advance = {
        areaId: undefined,
        areaName: '',
        regionName: '',
        submitUserId: undefined,
        request: '',
        contactUserName: '',
        deviceTypeIds: [],
        time: [],
        startTime: '',
        endTime: '',
        questionDescription: '',
        customerId: undefined,
        provinceId: undefined,
        provinceName: '',
        cityId: undefined,
        cityName: '',
        claimUser: undefined,
        isInvolvedMachine: '',
        workStationId: undefined,
      }
    },
    distribute(record) {
      this.distributeModelVisible = true
      this.$refs['distribute'].initData(record)
    },
    startHandle(record) {
      wrsp.claimWorkRecord(record.id).then(res=>{
        this.getData();
        this.selectedRow.id = '';
        setTimeout(() => {
          this.selectedRow.id = record.id;
        }, 100);
      })
    },
    handle(record) {
      this.$refs['handle'].initData(record)
      this.handleModelVisible = true
    },
    audit(record) {
      this.$refs['audit'].initData(record)
      this.auditModelVisible = true
    },
    edit(record) {
      this.workRecordId = record.id
      this.isEdit = true
      this.newModelVisible = true
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    toggleSearch() {
      this.advanceVisible = !this.advanceVisible
    },
    closeToggleSearch() {
      this.advanceVisible = false
    },
    startToggleSearch(value) {
      this.isAdvance = true
      this.filter.keywords = ''
      this.filter.advance = value
      this.pagination.current = 1
      this.advanceSearch()
    },
    handleAdd() {
      this.isEdit = false
      this.newModelVisible = true
    },
    handleDelete() {
      this.$confirm({
        title: this.$t('page_ops_work_record_delete'),
        content: this.$t('page_ops_work_record_delete_tip') + '?',
        okText: this.$t('delete'),
        okType: 'danger',
        cancelText: this.$t('cancel'),
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        onOk: () => {
          this.readyDelete()
        }
      })
    },
    async readyDelete() {
      const ids = this.selectedRowKeys.join(',')
      await wrsp.deleteWorkRecord(ids)
      this.$message.success(this.$t('page_ops_customer_delete_success'))
      this.selectedRow = {}
      this.selectedRowKeys = []
      this.selectedRowId = ''
      this.initPagination()
      this.getData()
    },
    keywordSearch() {
      this.isAdvance = false;
      this.resetSearch();
      this.initPagination()
      this.getData()
    },
    advanceSearch() {
      const params = this.getParams();
      wrsp
        .getWorkRecordList(
          this.pagination.current,
          params,
          this.pagination.pageSize
        )
        .then((res) => {
          this.pagination.total = res.total
          this.dataSource = res.records
          if(!res.records.length) {
            this.selectedRow = {}
          } else {
            this.selectedRow = this.dataSource[0]
          }
          this.setScroll(res)
        })
    },
    getData() {
      wrsp
        .getWorkRecordListByFuzzySearch(
          {
            keyValue: this.filter.keywords,
            processProgress: this.getFilterStatus()
          },
          this.pagination.current,
          this.pagination.pageSize
        )
        .then((res) => {
          this.isAdvance = false
          if (res.records.length) {
            this.pagination.total = res.total
            this.dataSource = res.records
            if (Object.keys(this.selectedRow).length === 0) {
              this.selectedRow = res.records[0]
            }
          } else {
            this.dataSource = []
            this.selectedRow = {}
            this.pagination.total = 0
          }
          this.setScroll(res)
        })
    },
    setScroll(data) {
      const dev = document.getElementById('table-list')
      if (dev) {
        const height = dev.clientHeight - 80
        if (height < data.records.length * 33) {
          this.scrollY = height
        } else {
          this.scrollY = 0
        }
      }
    },
    getFilterStatus() {
      if (
        (this.makinoJumpValue != '' || this.makinoJumpValue != undefined) &&
        this.makinoJumpValue.length > 0
      ) {
        this.filter.status = [this.makinoJumpValue + '']
        this.saveMakinoJump('')
      }

      return this.filter.status.length > 0 ? this.filter.status : this.filter.defaultAllStatus
    },
    async getStateDict() {
      let res = await dictServiceProxy.dictionary('work_record_status')
      this.dictList = res.data.filter((i) => i.dictKey > 0)
      this.filter.defaultAllStatus = this.dictList.map((x) => x.dictKey)
      this.filter.status = this.filter.defaultAllStatus.slice()
    },
    getStateValue(value) {
      let target = this.dictList.find((res) => res.dictKey == value)
      return target || { remark: '', dictValue: value }
    },
    inSearchStatus(value) {
      return this.filter.status.indexOf(value) > -1
    },
    inputStatus(value) {
      const newTags = [...this.filter.status]
      const status = this.filter.status.find((res) => res == value)
      if (!status) {
        this.filter.status.push(value)
      } else {
        this.filter.status = newTags.filter((res) => res != value)
      }
      this.initPagination()
      this.getData()
    },
    closeDistributeModel(isSuccess) {
      if (isSuccess) {
        this.initPagination()
        this.getData()
        const id = this.selectedRow.id;
        this.selectedRow.id = '';
        setTimeout(() => {
          this.selectedRow.id = id;
        }, 100);
      }
      this.distributeModelVisible = false
    },
    closeAuditModel(isSuccess) {
      if (isSuccess) {
        this.initPagination()
        this.getData()
      }
      this.auditModelVisible = false
    },
    closeHandleModel(isSuccess) {
      if (isSuccess) {
        this.initPagination()
        this.getData()
        const id = this.selectedRow.id;
        this.selectedRow.id = '';
        setTimeout(() => {
          this.selectedRow.id = id;
        }, 100);
      }
      this.handleModelVisible = false
    },
    okNewModel(){
      this.initPagination()
      this.getData()
      const id = this.selectedRow.id;
      this.selectedRow.id = '';
      setTimeout(() => {
        this.selectedRow.id = id;
      }, 100);
      this.newModelVisible = false
    },
    closeNewModel() {
      this.newModelVisible = false
    },
    clickRow(row) {
      this.selectedRow = row
      this.selectedRowId = row.id
      this.selectedRowKeys = [row.id]
    },
    exportWorkRecord() {
      const params = this.getParams();
      exportWorkRecord(params).then((res) => {
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        /* a.download = `${this.$t('page_plan_maintenance_items')}.xlsx` */
        a.download = `${this.$t('page_ops_work_record_export_name')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    initPagination() {
      this.pagination.current = 1
      this.pagination.pageSize = 20
    }
  }
}
</script>

<style lang="less" scoped>
.exception {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-list {
  width: 700px;
  position: relative;
}
.custom-detail {
  width: calc(100% - 700px);
  border-left: 1px solid #d7d7d7;
  height: 100%;
  overflow: auto;
}

.status-choose {
  align-items: center;
  @media screen and (max-width: 1505px) {
    min-width: 340px;
  }
}
.state-filter {
  background-color: white;
  padding: 5px;
  margin-right: 9px;
  border: 1px solid #d9d9d9;
}
</style>
